export default __webpack_public_path__ + "static/media/78.7f51924a.jpeg";